module.exports = __webpack_public_path__ + "static/img/logo.23ad2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/logo.png
// module id = 5Swk
// module chunks = 3